import { render, staticRenderFns } from "./BackofficeNegociacaoOperadora.vue?vue&type=template&id=74dd3014&scoped=true"
import script from "./BackofficeNegociacaoOperadora.vue?vue&type=script&lang=ts"
export * from "./BackofficeNegociacaoOperadora.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeNegociacaoOperadora.vue?vue&type=style&index=0&id=74dd3014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dd3014",
  null
  
)

export default component.exports